import { ActivatedRoute, Router } from '@angular/router';
import { PHBHPLayoutPackageService, PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Component, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { AppConfig } from '../../app.config';
import { Subscription } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'app-consumption',
  templateUrl: './consumption.component.html',
  styleUrls: ['./consumption.component.css']
})
export class ConsumptionComponent implements OnInit {

  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(public appConfig: AppConfig, public layoutService: PHBHPLayoutPackageService, private service: PHBHPListApiService, private modalService: BsModalService) { }

  selectedInstitution;
  InstitutionsList: any = [];
  subscription: Subscription;
  subscriptionInstitution: Subscription;
  modalRef: BsModalRef;
  @ViewChild('template') template: TemplateRef<any>;
  selected = 0;
  mygroup = new UntypedFormGroup({
    selectedIns: new UntypedFormControl(this.selected)
  });

  ngOnInit() {
    if (this.appConfig.institutions) {
      this.selected = this.layoutService.institutionID;
      this.getInstitutionsbyId()
    } else {
      this.subscription = this.appConfig.userSubject.asObservable().subscribe((res) => {
        this.selected = this.layoutService.institutionID;
        this.getInstitutionsbyId()
      })
    }

    this.subscriptionInstitution = this.layoutService.institutionIDSubject.asObservable().subscribe((res)=>{
      this.selected = this.layoutService.institutionID;
      this.selectedInstitution = this.InstitutionsList.find(x => x.institution.institutionID === this.layoutService.institutionID)?.institution?.institutionName || '';
    })
  }

  onInstitutionChange(id){
    this.layoutService.institutionID = id;
    this.layoutService.institutionIDSubject.next(id);
    this.selectedInstitution = this.InstitutionsList.find(x => x.institution.institutionID === id)?.institution?.institutionName || '';
  }

  showInstitutionDropDown() {
    if (this.InstitutionsList) {
      if (this.InstitutionsList.length < 2) {
        return false;
      } else {
        return true;
      }
    }
  }
  getInstitutionsbyId() {
    var roleId = this.appConfig.userData.roleName.roleId;
    this.service.getInstitutionsbyId(this.appConfig.institutions, roleId).subscribe((res: any) => {
      this.InstitutionsList = res;
      if(this.layoutService.institutionID)
        this.selectedInstitution = this.InstitutionsList.find(x => x?.institution?.institutionID === this.layoutService.institutionID)?.institution?.institutionName;
    });
  }
  getInstitutionName() {
    if (this.InstitutionsList) {
      return this.InstitutionsList[0].institution.institutionName;
    }
  }
  openmodal(template: TemplateRef<any>){
    this.mygroup.patchValue({
      selectedIns : this.selected
    })
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'w-420' }));
  }
  ngOnDestroy(){
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    if(this.subscriptionInstitution)
      this.subscriptionInstitution.unsubscribe();
  }
}
